import { Link } from "react-router-dom";

const quickLinks = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "Our Artists", path: "/artists" },
  { label: "YouTube Network", path: "/youtube-network" },
  { label: "Services", path: "/services" },
  { label: "Contact Us", path: "/contact" },
];

const serviceLinks = [
  { label: "YouTube Services", path: "/services/youtube-services" },
  { label: "Music Production", path: "/services/music-production" },
  { label: "Audio Recording", path: "/services/audio-recording" },
  { label: "Video Production", path: "/services/video-production" },
  { label: "Artist Management", path: "/services/artist-management" },
  { label: "Digital Promotion", path: "/services/digital-promotion" },
  
];

export default function Footer() {
  return (
    <footer className="bg-[#080808] border-t border-[#d4af37]/10">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
           <img
  src="/images/gangadigital.png"
  alt="Ganga Digital"
  className="h-14 w-auto object-contain mb-4"
/>
            <p className="text-white/60 text-sm leading-relaxed mb-5">
              India's leading music label &amp; digital entertainment network. Empowering artists since 1992.
            </p>
            <div className="flex items-center gap-4">
              <a href="https://www.facebook.com/gangamusicofficial" target="_blank" rel="nofollow noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-[#d4af37]/30 text-white/60 hover:text-[#d4af37] hover:border-[#d4af37] transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-base" />
              </a>
              <a href="https://www.instagram.com/gangadigitalofficial/" target="_blank" rel="nofollow noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-[#d4af37]/30 text-white/60 hover:text-[#d4af37] hover:border-[#d4af37] transition-colors cursor-pointer">
                <i className="ri-instagram-line text-base" />
              </a>
              <a href="https://www.youtube.com/@GangaCassette" target="_blank" rel="nofollow noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-[#d4af37]/30 text-white/60 hover:text-[#d4af37] hover:border-[#d4af37] transition-colors cursor-pointer">
                <i className="ri-youtube-fill text-base" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold text-base mb-5 font-heading">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((l) => (
                <li key={l.path}>
                  <Link to={l.path} className="text-white/60 text-sm hover:text-[#d4af37] transition-colors flex items-center gap-2">
                    <i className="ri-arrow-right-s-line text-[#d4af37] text-xs" />
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold text-base mb-5 font-heading">Our Services</h4>
            <ul className="space-y-3">
              {serviceLinks.map((l) => (
                <li key={l.path}>
                  <Link to={l.path} className="text-white/60 text-sm hover:text-[#d4af37] transition-colors flex items-center gap-2">
                    <i className="ri-arrow-right-s-line text-[#d4af37] text-xs" />
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold text-base mb-5 font-heading">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-[#d4af37] mt-0.5 flex-shrink-0" />
                <span className="text-white/60 text-sm">B-40 DSIDC Complex Kirti Nagar, New Delhi - 110015</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-phone-line text-[#d4af37] flex-shrink-0" />
                <a href="tel:09990194423" className="text-white/60 text-sm hover:text-[#d4af37] transition-colors">09990194423</a>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-phone-line text-[#d4af37] flex-shrink-0" />
                <a href="tel:9911122200" className="text-white/60 text-sm hover:text-[#d4af37] transition-colors">9911122200</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10 px-4 md:px-6 py-5">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-sm">© 2026 Ganga Digital. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-white/40 text-sm hover:text-[#d4af37] transition-colors">Privacy Policy</a>
            <a href="#" className="text-white/40 text-sm hover:text-[#d4af37] transition-colors">Terms of Use</a>
            <a href="#" className="text-white/40 text-sm hover:text-[#d4af37] transition-colors">Sitemap</a>
          </div>
        </div>
      </div>

      {/* WhatsApp Floating */}
      <a
        href="https://wa.me/919990194423"
        target="_blank"
        rel="nofollow noreferrer"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 flex items-center justify-center rounded-full text-white text-2xl transition-transform duration-300 hover:scale-110 cursor-pointer bg-green-500"
        aria-label="Chat on WhatsApp"
      >
        <i className="ri-whatsapp-line" />
      </a>
    </footer>
  );
}
